import React, { Component } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ConfigProvider } from 'antd';
import store from './redux/store';
import MainApp from './container/MainApp';
import { NotificationContainer } from 'react-notifications';

import './assets/css/custom.css';
import 'react-notifications/lib/notifications.css';
//import "react-big-calendar/lib/css/react-big-calendar.css";
// locale
import dayjs from 'dayjs';
import moment from 'moment';
import 'dayjs/locale/fr';
import 'moment/locale/fr';
import frFR from 'antd/locale/fr_FR';
// without this line it didn't work
// import vi_VN from 'antd/lib/locale-provider/vi_VN';
import Wrapper from './lang';
import { setChonkyDefaults } from 'chonky';
import { ChonkyIconFA } from 'chonky-icon-fontawesome';
import {
  QueryClient,
  QueryClientProvider,
  useQuery,
} from '@tanstack/react-query';
import 'moment-timezone';
// moment.locale('vi');
moment.locale('fr');
dayjs.locale('fr');
moment.tz.setDefault('Asia/Bangkok');
setChonkyDefaults({ iconComponent: ChonkyIconFA });
const queryClient = new QueryClient();
export default class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <ConfigProvider
          locale={frFR}
          theme={{
            token: {
              colorPrimary: '#16bc8c',
              borderRadiusBase: '2px',
            },
            components: {
              Switch: {
                colorPrimary: '#00b96b',
              },
            },
          }}>
          <BrowserRouter>
            <Wrapper>
              <QueryClientProvider client={queryClient}>
                <MainApp />
              </QueryClientProvider>
            </Wrapper>
            <NotificationContainer />
          </BrowserRouter>
        </ConfigProvider>
      </Provider>
    );
  }
}
